import React from 'react';
import './Skeleton.css';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Skeleton component (framework-agnostic CSS)
 * Props:
 * - variant: 'default' | 'circle' | 'rounded' | 'square'
 * - width: string | number
 * - height: string | number
 * - animation: 'pulse' | 'wave' | 'none'
 * - shimmer: boolean
 * - count: number
 * - className: string
 */
export default function Skeleton({
  className,
  variant = 'default',
  width,
  height,
  animation = 'pulse',
  shimmer = false,
  count = 1,
  style: styleProp,
  ...props
}) {
  const variantClasses = {
    default: 'skeleton-rounded-md',
    circle: 'skeleton-rounded-full',
    rounded: 'skeleton-rounded-xl',
    square: 'skeleton-rounded-none',
  };

  const animationClasses = {
    pulse: 'skeleton-animate-pulse',
    wave: 'skeleton-animate-shimmer',
    none: '',
  };

  const style = {
    width: width !== undefined ? (typeof width === 'number' ? `${width}px` : width) : undefined,
    height: height !== undefined ? (typeof height === 'number' ? `${height}px` : height) : undefined,
    ...styleProp,
  };

  const baseClasses = cx(
    'skeleton-base',
    variantClasses[variant],
    animationClasses[animation],
    shimmer ? 'skeleton-shimmer' : '',
    className
  );

  if (count > 1) {
    return (
      <div className={cx('skeleton-stack', className)} {...props}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={baseClasses} style={style} />
        ))}
      </div>
    );
  }

  return <div className={baseClasses} style={style} {...props} />;
}